
import tbAdministrationStateConstants from "./Constants";
import TbSubscriptionManagementController from "./TbSubscriptionManagementController";

import Assert from "tbAssert";

function TbSubscriptionManagementConfiguration($stateProvider, $urlRouterProvider) {
    Assert.StrictAssert(($stateProvider != null), "Assertion Failure: Missing Or Null State Provider");
    Assert.StrictAssert(($urlRouterProvider != null), "Assertion Failure: Missing Or Null UI Router Url Router Provider");

    $stateProvider
        .state(tbAdministrationStateConstants.rootStateName, {
            url: "/admin",
            abstract: true,
            template: "<ui-view></ui-view>",
            data: {
                requiresLogin: true
            }
        })
        .state(`${tbAdministrationStateConstants.rootStateName}.${tbAdministrationStateConstants.managementPage.stateName}`, {
            url: "/subscriptions/{rcptId}",
            template: TbSubscriptionManagementController.template,
            controller: TbSubscriptionManagementController,
            controllerAs: TbSubscriptionManagementController.controllerAs,
            params: {
                rcptId: { squash: true, value: null, dynamic: true }
            }
        });

    $urlRouterProvider.when("/admin", "/admin/subscriptions");
}

TbSubscriptionManagementConfiguration.$inject = [ "$stateProvider", "$urlRouterProvider" ];

TbSubscriptionManagementConfiguration.dependencies = [
    "ui.router"
];

export default TbSubscriptionManagementConfiguration;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/TbSubscriptionManagementConfiguration.js
// module id = dfwR
// module chunks = 1